import {  Component, 
          forwardRef, 
          OnDestroy,
          OnInit,
          Input, 
          ChangeDetectionStrategy, 
  } from '@angular/core';
import {  ControlValueAccessor, 
          NG_VALUE_ACCESSOR, 
          FormBuilder,
          FormGroup,          
          Validators,
          FormControl,
          NG_VALIDATORS
           } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LookupService } from 'src/app/core/services/lookup.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { BaseDynamicForm } from 'src/app/core/services/base-dynamic-form';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserProcessProfileService } from 'src/app/core/services/user-process-profile.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilsService } from 'src/app/core/services/utils.service';

export interface agentInfo {

  name: string;
  secondName: string;
  lastName: string;
  secondLastName: string;
  socialSecurityNumber:string;
  agentAddresses: string;
  primaryPhone: string;
  email: string;
}

@Component({
  selector: 'prgov-agente',
  templateUrl: './agente.component.html',
  styleUrls: ['./agente.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgenteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AgenteComponent),
      multi: true,
    }
  ],
})
export class AgenteComponent extends BaseDynamicForm implements ControlValueAccessor, OnDestroy, OnInit {

    @Input() public isLinear: boolean;
    @Input() public isReview: boolean;
    @Input() agente: any = "";

    form1: FormGroup;
    langKey: any = 'SELECTED_LANGUAGE';
    subscriptions: Subscription[] = [];
    profile: any;
    soliciter: any;
    solicitant: any;
    showPassword: boolean = false;

    get value(): agentInfo {
      console.log("this.form1.value")
      console.log(this.form1.value)
      return this.form1.value;
    }
  
    set value(value: agentInfo) {
      this.form1.patchValue(value);
      this.onChange(value);
      this.onTouched();
    }

    constructor(    
        private formBuilder: FormBuilder,
        private matSnackBar: MatSnackBar,
        public translate: TranslateService,
        public lookupService: LookupService,
        public ls: LsHelperService, 
        public dynamicFormService: DynamicFormService,
        public authService: AuthService,
        public userProcessProfileService: UserProcessProfileService,

    ) { 
        super();  
        translate.use(this.ls.get(this.langKey));
       
        this.formQty = 1;

        this.form1 = this.formBuilder.group({
          "name": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
          "secondName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
          "lastName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
          "secondLastName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
          "socialSecurityNumber": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
          "agentAddresses": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],         
          "primaryPhone": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
          "email": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([Validators.maxLength(70), Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])],
         });  
      
        this.subscriptions.push(
          this.form1.valueChanges.subscribe(value => {
           this.onChange(value);
           this.onTouched();
         })
        )
        
    }
    onChange: any = () => {};
    onTouched: any = () => {};

    writeValue(obj: any): void {
      if (obj) {
        this.value = obj;
      }    

      if (obj === null) {
        this.form1.reset();
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }
      
    validate(formControl: FormControl) {
      var returnValue = null;

      if(!this.form1.valid){
        returnValue = { profile: { valid: false } };;
      }

      console.log(this.form1.valid)

      return returnValue;
    }

    setDisabledState?(isDisabled: boolean): void {
      throw new Error('Method not implemented.');
    }

    ngOnInit() {     
    }  
    
    ngOnDestroy() {
      this.subscriptions.forEach(s => s.unsubscribe());
    }
    
    toggleSSN(){
      this.showPassword = !this.showPassword;
    }

    setValidators(locationType) {
      let state = locationType.get('State').value; 
      let country = locationType.get('Country').value; 

        if (locationType === 1) {
            state.setValidators(Validators.required)
            country.setValidators(null)
        } 
        else {      
            state.setValidators(null);
            country.setValidators(Validators.required)
        }
    }
    
    printFormValidation(){
      var utils = new UtilsService();
  
      console.log(utils.findInvalidControls(this.form));     
    }
}
